import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
var Destini = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Destini, _React$Component);
  function Destini(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      params: ''
    };
    return _this;
  }
  var _proto = Destini.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var script = document.createElement('script');
    script.src = "https://destinilocators.com/" + this.props.siteID + "/site/install/";
    script.async = true;
    document.body.appendChild(script);
    this.setState({
      params: window.location.search ? window.location.search.replace('?', '&') : '',
      origin: this.props.origin ? this.props.origin : window.location.origin
    });
  };
  _proto.render = function render() {
    var _this$props = this.props,
      siteID = _this$props.siteID,
      showMap = _this$props.showMap;
    return /*#__PURE__*/React.createElement("iframe", {
      id: "destini",
      src: "https://destinilocators.com/" + siteID + "/site/locator.php?RFR=" + this.state.origin + (showMap ? '&MM=panel2' : '') + this.state.params,
      scrolling: "no",
      frameBorder: "0",
      style: {
        width: '100%',
        height: 'auto'
      },
      allow: "geolocation"
    });
  };
  return Destini;
}(React.Component);
export { Destini as default };